export default {
  root: {
    padding: 24,
    marginBottom: 16,
  },
};
